module.exports = __webpack_public_path__ + "img/9788996575894.72c7a553.jpg";